import React from "react";

type TitleProps = React.PropsWithChildren<{
    className?: string;
    color?: "blue" | "green" | "rose" | "brown" | "white" | "pink";
}>;

export const Title: React.FC<TitleProps> = ({ children, className = "", color }) => {
    let colorClass = "";

    if (!color) {
        colorClass = "text-slate-600";
    }

    if (color === "white") {
        colorClass = "text-white";
    }

    if (color === "blue") {
        colorClass =
            "!text-blueLight";
    }
    if (color === "green") {
        colorClass =
            "text-greenLight";
    }
    if (color === "rose") {
        colorClass = "text-roseExtraLight";
    }
    if (color === "brown") {
        colorClass = "text-roseExtraLight";
    }

    if (color === "pink") {
        colorClass = "text-[#f4c1d0]"; // or whatever blush tone you prefer
    }

    return <div className={`header ${colorClass} ${className}`}>{children}</div>;
};
